<template>
  <ElDialog
    width="35%"
    :title="$t('AUTH.STEPS.IDENTITY_VERIFICATION.CELLPHONE_VERIFICATION')"
    :visible="value"
    class="update-phone-number-modal"
    @close="emitInputValue"
  >
    <div
      v-dompurify-html="modalMessage"
      class="update-phone-number-modal__description"
    />

    <div v-if="errorMessage" class="text-alert">
      {{ errorMessage }}
    </div>

    <div class="update-phone-number-modal__code">
      <div class="update-phone-number-modal__input-wrapper">
        <ElInput
          v-model="code"
          type="numeric"
          maxlength="4"
          class="update-phone-number-modal__input"
          placeholder="####"
          dir="ltr"
          @keypress.enter.native="verifyPhoneNumber"
        />
      </div>

      <div class="update-phone-number-modal__actions">
        <ElButton
          icon="el-icon-refresh"
          size="mini"
          :disabled="resendDisabled"
          :loading="sendingSms"
          @click.native="sendVerificationCode"
        >
          {{ $t('AUTH.STEPS.IDENTITY_VERIFICATION.RESEND_BTN') }}
          <template v-if="waitTime">:&nbsp;{{ waitTime }}</template>
        </ElButton>
      </div>
    </div>

    <template #footer>
      <div class="update-phone-number-modal__buttons">
        <ElButton type="text" size="mini" @click.native="emitInputValue">
          {{ $t('CANCEL') }}
        </ElButton>
        <ElButton
          type="primary"
          size="mini"
          :loading="loading"
          @click.native="verifyPhoneNumber"
        >
          {{ $t('CONFIRM') }}
        </ElButton>
      </div>
    </template>
  </ElDialog>
</template>

<script>
import { PhoneNumber } from '@/api/api';
export default {
  name: 'UpdatePhoneNumberModal',
  props: {
    phoneNumber: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    waitTime: {
      type: Number,
      default: 0,
    },
    sendingSms: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      code: '',
      loading: false,
      errorMessage: null,
    };
  },
  computed: {
    resendDisabled() {
      return Boolean(this.waitTime || this.sendingSms);
    },

    modalMessage() {
      if (this.sendingSms) {
        return this.$t(
          'AUTH.STEPS.IDENTITY_VERIFICATION.MESSAGE_SENDING_DESC',
          {
            phone: this.phoneNumber,
          },
        );
      }
      return this.$t('AUTH.STEPS.IDENTITY_VERIFICATION.MESSAGE_DESC', {
        phone: this.phoneNumber,
      });
    },
  },

  watch: {
    phoneNumber() {
      this.errorMessage = null;
      this.code = '';
    },
  },

  methods: {
    emitInputValue() {
      if (!this.loading) {
        this.$emit('input', false);
      }
    },

    sendVerificationCode() {
      this.errorMessage = null;
      this.$emit('send-sms');
    },

    verifyPhoneNumber() {
      if (this.code.length < 4) {
        return false;
      }

      this.loading = true;
      this.errorMessage = null;
      return PhoneNumber.verifyCode({ verification_code: this.code })
        .then(({ body: { message } }) => {
          this.$message.success(message);
          this.$emit('verify');
        })
        .catch(({ body: { message } }) => {
          if (message) {
            this.$message.error(message);
          }

          this.errorMessage = message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.update-phone-number-modal {
  $base: &;
  $transition: 150ms ease;

  margin: 2 * $global-margin 0;

  &__buttons {
    text-align: right;

    @include rtl() {
      text-align: left;
    }
  }

  &__input-wrapper {
    height: rem-calc(100);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__input {
    height: rem-calc(40);
    flex-basis: rem-calc(200);

    input {
      text-align: center;
      letter-spacing: rem-calc(5);
      text-indent: rem-calc(5);
    }
  }

  &__actions {
    text-align: center;

    button {
      margin: 0 !important;
      min-width: rem-calc(150);
    }
  }
}
</style>
